import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  font-weight: bolder;
  padding: 1rem 4rem;
  height: 7vh;
  box-shadow: 2px 2px 0.4rem rgba(0, 0, 0, 0.3);
  z-index: 2;
`;

export const Logo = styled.img`
  max-width: 7rem;
  position: absolute;
  left: 45%;
  right: 45%;
`;

export const Container = styled(Box)`
  display: flex;
  flex-direction: column; /* Organiza os filhos verticalmente */
  height: 100%; /* Ocupa 100% da altura da tela */
`;

export const Content = styled(Box)`
  display: flex;
  flex-direction: row;
  min-height: 100%; /* Define um tamanho mínimo para preencher o pai */
  background-color: inherit;
  height: 93vh;
`;

export const SideBar = styled(Box)`
  height: 100%;
  width: 100%;
  max-width: 300px;
  overflow: auto;

  scrollbar-width: thin;
  scrollbar-color: #c5c5c5 transparent;

  /* Works on Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 10px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    padding: 4px;
    background-color: #c5c5c5;
    background-size: contain;
    border-radius: 20px;
    border: 3px solid transparent;
  }
`;
